import { Chart, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartTitle, ChartLegend } from "@progress/kendo-react-charts";
import { useApiTrigger } from "../../hooks/useApiTrigger";
import { forwardRef, useImperativeHandle } from "react";

const ComplexColumnChart = forwardRef(({ data, filters, returnData }, ref) => {
    const { dto } = useApiTrigger(data, filters);

    const getData = () => {
        const fileName = data.accion || 'Reporte_Grafica';
        returnData(dto, fileName);
    };

    useImperativeHandle(ref, () => ({
        exportChartData: getData,
    }));

    return (
        <Chart style={{ width: "100%", height: "100%" }}>
            <ChartTitle text={data.accion} />
            <ChartLegend position="top" orientation="horizontal" />
            <ChartCategoryAxis>
                <ChartCategoryAxisItem
                    categoriesField="category"
                    startAngle={45}
                />
            </ChartCategoryAxis>
            <ChartSeries>
                {
                    dto.length > 0 &&
                    Object.keys(dto[0]).map((key, idx) => (
                        key !== 'category' &&
                        <ChartSeriesItem
                            key={idx}
                            type="column"
                            data={dto}
                            categoryField="category"
                            field={key}
                            name={key}
                            tooltip={{ visible: true }}
                            labels={{
                                visible: true,
                                format: "{0}",
                                position: "outsideEnd"
                            }}
                        />
                    ))
                }
            </ChartSeries>
        </Chart>
    )
})
export default ComplexColumnChart